import api from "../config/api";
import { dataConfigType, getDataConfigType } from "./test/data-config";
import { getTestData } from './test/teams-data';

export async function get(id, filter, pageData) {
  const currentDataConfigType = getDataConfigType();

  switch (currentDataConfigType) {
    case dataConfigType.LIVEDATA: {
      const ALL = -1;
      const sortColumn = pageData.columnName,
            sortDirection = pageData.order,
            page = pageData.page + 1,
            limit = pageData.rowsPerPage === ALL ? '' : pageData.rowsPerPage;
      const url = `${wbConfig.baseUrl}/restapi/engagementReport/teamBreakDown/?userId=${id}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&page=${page}&limit=${limit}`;
      const { data: { data = [] } = [] } = await api.get(url);
      return data ? data : [];

    }
    case dataConfigType.TESTDATA1:
    case dataConfigType.TESTDATA2: {
      const data = getTestData(currentDataConfigType, pageData);
      return new Promise(ok => {
        setTimeout(() => {
          ok(() => {
            console.log(`teamBreakdown (${(currentDataConfigType === dataConfigType.TESTDATA1) ? 'TESTDATA1' : 'TESTDATA2'})`, id, data);
            return id === 1 ? data : [];
          });
        }, 1500);
      });
    }
    default: return undefined;
  }
}

export async function getQuarters() {
  const { data: { filterComp = [] } = [] } = await api.get(
    `${wbConfig.baseUrl}/goal/okrFilterComp?fromFilter=1`
  );

  return filterComp.map(({ name, ...rest }) => ({
    name,
    customPeriod: name === "Custom time period",
    ...rest
  }));
}

export default {
  get,
  getQuarters
};
